<script setup lang="ts">
// The file decal can be one of several things:
//
// - The uploading indicator
// - The downloading indicator
// - (For links) the external link indicator/icon
// - (TBD) unread indicator
// - (TBD) activity indicator

defineProps({
  file: null,
  selected: { type: Boolean }
})

const isUpload = ref(false) // FIXME
const isDownload = ref(false) // FIXME
</script>

<template>
  <div class="file-decal">
    <div v-if="isUpload" class="upload-decal">
      <icon-action type="arrow-up" size="xs" />
    </div>
    <div v-else-if="isDownload" class="download-decal">
      <icon-action type="arrow-up" size="xs" />
    </div>
    <!-- <div v-else-if="isLink" class="link-decal">
      <icon-property size="xs" type="external" size="xs" />
    </div> -->
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.file-decal
  @apply h-5 max-w-5 items-center flex

.upload-decal
  @apply bg-$global-blue-accent rounded-full h-5 w-5 flex items-center justify-center text-$global-blue-primary

.download-decal
  @apply bg-$global-green-accent rounded-full h-5 w-5 flex items-center justify-center text-$global-green-primary

.link-decal
  @apply
</style>
